import { motion } from "framer-motion";
import Reveal, { EASE } from "@/components/Reveal";

export default function Team() {
    return (
        <section id="team" data-testid="team-section" className="bg-white py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
                    <div>
                        <Reveal>
                            <p className="text-xs font-medium uppercase tracking-[0.3em] text-[#B88282]">Il team</p>
                        </Reveal>
                        <Reveal delay={0.1}>
                            <h2 className="mt-4 font-serif text-4xl leading-tight tracking-tight sm:text-5xl">
                                Professionisti che condividono un <span className="italic text-[#B88282]">percorso</span>.
                            </h2>
                        </Reveal>
                        <Reveal delay={0.2}>
                            <p className="mt-6 text-base leading-relaxed text-[#5A5A5A] sm:text-lg">
                                Alle spalle di GPS srls ci sono persone con oltre dieci anni di esperienza in
                                consulenza, formazione e sviluppo organizzativo. Un gruppo che ha scelto di mettere in
                                comune competenze diverse per offrire un supporto autentico e concreto.
                            </p>
                        </Reveal>
                        <Reveal delay={0.3}>
                            <div className="mt-10 flex items-center gap-4 border-t border-[#1A1A1A]/10 pt-8">
                                <img
                                    src="/assets/logo-pink.png"
                                    alt=""
                                    aria-hidden="true"
                                    className="h-16 w-auto object-contain"
                                />
                                <p className="max-w-xs font-serif text-lg italic leading-snug text-[#1A1A1A]/70">
                                    "GPS perché ti portiamo verso il tuo obiettivo."
                                </p>
                            </div>
                        </Reveal>
                    </div>
                    <Reveal delay={0.15}>
                        <motion.div
                            whileHover={{ scale: 0.985 }}
                            transition={{ duration: 0.6, ease: EASE }}
                            className="overflow-hidden rounded-2xl"
                        >
                            <motion.img
                                initial={{ scale: 1.15 }}
                                whileInView={{ scale: 1 }}
                                viewport={{ once: true }}
                                transition={{ duration: 1.4, ease: EASE }}
                                src="https://images.unsplash.com/photo-1758873269117-d5845126928a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
                                alt="Il team GPS srls in collaborazione"
                                className="aspect-[4/5] w-full object-cover lg:aspect-[5/6]"
                                loading="lazy"
                            />
                        </motion.div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
